import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer, Navbar } from "@/components/chrome";

const LegalLayout = ({ title, testid }) => {
  useEffect(() => {
    document.title = `${title} — Donna Virtuosa`;
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <main className="mx-auto max-w-3xl px-6 py-20 md:px-10 md:py-28" data-testid={testid}>
        <h1 className="font-serif text-4xl tracking-tight text-[#1A1818] md:text-5xl">{title}</h1>
        <div className="mt-6 h-px w-24 bg-[#D4AF37]" aria-hidden="true" />
        <p className="mt-10 text-base leading-relaxed text-[#3A3532] md:text-lg">
          Contenuto in fase di preparazione. Questa pagina verrà aggiornata a breve con il testo
          completo.
        </p>
        <p className="mt-4 text-base leading-relaxed text-[#3A3532] md:text-lg">
          Per qualsiasi informazione puoi scrivere direttamente a Chiara su WhatsApp.
        </p>
        <Link
          to="/"
          data-testid="legal-back-home"
          className="mt-12 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#A98A2C] transition-colors duration-300 hover:text-[#1A1818]"
        >
          <ArrowLeft className="h-4 w-4" strokeWidth={1.75} />
          Torna alla pagina principale
        </Link>
      </main>
      <Footer />
    </div>
  );
};

export const PrivacyPage = () => <LegalLayout title="Privacy Policy" testid="privacy-page" />;
export const CookiePage = () => <LegalLayout title="Cookie Policy" testid="cookie-page" />;
export const TerminiPage = () => <LegalLayout title="Termini e Condizioni" testid="termini-page" />;
